import { render } from "./AccountNextStepsProfile.vue?vue&type=template&id=16e80585"
import script from "./AccountNextStepsProfile.vue?vue&type=script&lang=js"
export * from "./AccountNextStepsProfile.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__